// Sportdings is English-only for now (owner, 2026-10-13: "fine with just English"): most of the UI has no German
// text, so following a German browser produced a mix. Restore the navigator check once every string is translated.
export const isGerman = () => false;
export const text = (german: string, english: string) => isGerman() ? german : english;
